<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card tab2-card">
                <div class="card-header pb-0">
                    <h5 *ngIf="type == 'add'" class="text-capitalize">Add Content Folder</h5>
                    <h5 *ngIf="type == 'edit'" class="text-capitalize">Edit Content Folder</h5>
                    <label class="text-muted">All fields marked with <span class="text-danger">*</span> are required</label>
                </div>
                <div class="card-body tab2-card">
                    <form [formGroup]="folderForm" class="needs-validation user-add">
                        <div class="form-group col-12 d-flex mt-4 justify-content-center">
                            <label class="col-12 col-md-4 col-xl-3" for="validationCustom1"><span>*</span>
                                Name</label>
                            <div class="col-12 col-md-7 col-xl-8">
                                <input class="form-control " formControlName="name" id="validationCustom1"
                                       placeholder="Name" required="" type="text">
                                <em *ngIf="!folderForm.get('name').valid && (folderForm.get('name').dirty || folderForm.get('name').touched)" class="error">Name is required</em>
                            </div>
                        </div>
                        <div class="form-group col-12 d-flex justify-content-center">
                            <label class="col-12 col-md-4 col-xl-3" for="validationCustom5"><span>*</span>
                                Status</label>
                            <div class="col-12 col-md-7 col-xl-8">
                                <select class="form-control" formControlName="status" id="validationCustom5">
                                    <option disabled selected>&#45;&#45;Select Status&#45;&#45;</option>
                                    <option value="1">Active</option>
                                    <option value="2">In-Active</option>
                                </select>
                                <em *ngIf="!folderForm.get('status').valid && (folderForm.get('status').dirty || folderForm.get('status').touched)" class="error">Status is required</em>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-footer px-4 py-3">
                    <div class="pull-right">
                        <button (click)="addFolder('add')" *ngIf="type == 'add'" class="btn btn-primary" type="button">Save</button>
                        <button (click)="addFolder('edit')" *ngIf="type == 'edit'" class="btn btn-primary" type="button">Update</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
